import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { COMPANY, NAV_ITEMS } from "@/lib/constants";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    setTimeout(() => scrollToId(id), 60);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0A1128]/95 backdrop-blur-md" : "bg-[#0A1128]"
      }`}
      style={{ borderBottom: "1px solid rgba(255,255,255,0.06)" }}
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="flex items-center justify-between h-[78px]">
          <button
            data-testid="logo-home-link"
            onClick={() => scrollToId("hero")}
            className="flex items-center gap-3 group"
            aria-label="Ramo Advisors LLC Home"
          >
            <img
              src={COMPANY.logo}
              alt="Ramo Advisors LLC"
              className="h-10 md:h-11 w-auto"
              style={{ filter: "drop-shadow(0 2px 10px rgba(0,168,89,0.15))" }}
            />
            <span className="hidden sm:inline-flex flex-col leading-none">
              <span className="font-heading text-white text-[15px] font-semibold tracking-wide">
                RAMO ADVISORS
              </span>
              <span className="font-body text-[10px] tracking-[0.28em] text-white/50 mt-1">
                LLC
              </span>
            </span>
          </button>

          <nav className="hidden lg:flex items-center gap-9" aria-label="Primary">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.id}
                data-testid={`nav-${item.id}`}
                className="ra-nav-link"
                onClick={() => handleNav(item.id)}
              >
                {item.label}
              </button>
            ))}
          </nav>

          <div className="hidden lg:block">
            <button
              data-testid="nav-cta-button"
              onClick={() => handleNav("contact")}
              className="ra-btn-primary"
              style={{ padding: "12px 22px", fontSize: "12px" }}
            >
              Schedule a Consultation
            </button>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-white p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {open && (
          <div data-testid="mobile-menu" className="lg:hidden pb-6">
            <div className="flex flex-col gap-1 pt-2 border-t border-white/10">
              {NAV_ITEMS.map((item) => (
                <button
                  key={item.id}
                  data-testid={`mobile-nav-${item.id}`}
                  className="text-left text-white/85 hover:text-white py-3 px-1 font-body text-[15px] border-b border-white/5"
                  onClick={() => handleNav(item.id)}
                >
                  {item.label}
                </button>
              ))}
              <button
                data-testid="mobile-nav-cta"
                onClick={() => handleNav("contact")}
                className="ra-btn-primary mt-4"
                style={{ padding: "14px 22px", fontSize: "12px" }}
              >
                Schedule a Consultation
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
